import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {LensModel} from '../../../models/api/lensModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

/*
 * Reducer.
 */

const lensesUpdatedReducer = createResourcesUpdatedReducer('lenses', (lens) => lens.id);

export function lensesReducer(state: ResourceMap<LensModel>, action: AppAction): ResourceMap<LensModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return lensesUpdatedReducer(state, action);

    // TODO-LENS: Add deleted case here when we add edit/delete flows.

    default:
      return state;
  }
}
